<template>
    <div class="build-report">
        <workflow-layout>
            <template v-slot:header>
                <workflow-header mwc-id="workflow-header" :component-config="headerConfig" v-on="events"></workflow-header>
            </template>
            <ReportGenerator ref="reportSettings" :mwc-id="getMwcIdForChild('reportSettings')" />
        </workflow-layout>
        <header-dialog
            :mwc-id="getMwcIdForChild('headerDialog')"
            :show="showDialog"
            :headerDialogConfig="dialogConfig"
            @dialog-close="dialogCloseHandler"
        ></header-dialog>
        <save-dialog :mwc-id="getMwcIdForChild('saveDialog')" :show="showSaveDialog" @save-event="handleSaveDialog"></save-dialog>
    </div>
</template>

<script>
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import HypoWorkflowMixin from "@/mixins/HypoWorkflowMixin";
import HeaderConfigMixin from "@/mixins/HeaderConfigMixin";
import WorkflowLayout from "../layouts/WorkflowLayout";
import WorkflowHeader from "hypo-workflow-header/src/WorkflowHeader";
import ReportGenerator from "../ReportOption/ReportGenerator";
import HeaderDialog from "./HeaderDialog";
import SaveDialog from "./SaveDialog";
import * as types from "@/store/mutation-types";

export default {
    name: "build-report",
    mixins: [MwcSharedMixin, HypoWorkflowMixin, HeaderConfigMixin],
    components: {
        WorkflowLayout,
        WorkflowHeader,
        ReportGenerator,
        HeaderDialog,
        SaveDialog
    },
    data() {
        return {
            events: {
                generate: () => this.generateReportHandler(this),
                back: () => this.backHandler(this),
                close: () => this.closeHandler(this),
                closeNotSave: () => this.closeNotSaveHandler(this),
                rename: () => this.renameHandler(this),
                delete: () => this.deleteHandler(this),
                "step-clicked": step => this.handleStepClicked(step)
            },
            showDialog: false,
            showSaveDialog: false,
            dialogConfig: {}
        };
    },
    beforeMount() {
        this.dialogConfig = this.defaultDialogConfig;
    },
    methods: {
        generateReportHandler(instance) {
            this.handleMoreThanOneYearOlderWarning();
            this.$refs.reportSettings.handleGenerateReport();
        },
        closeHandler(instance) {
            this.saveLastStep(this.currentStep.keyString);
            this.checkHypoCount();
        },
        closeNotSaveHandler(instance) {
            this.$store.commit(`hypo/${types.SET_FIRM_SAVED}`, false);
            this.$store.dispatch("clearHypoInput");
            this.$router.push("/type");
        },
        backHandler(instance) {
            this.$router.push(this.currentStep.previousRoute);
        },
        renameHandler(instance) {
            this.dialogConfig = this.getDialogConfig("rename", "hypo", null);
            this.showDialog = true;
        },
        deleteHandler(instance) {
            this.dialogConfig = this.getDialogConfig("delete", "hypo", null);
            this.showDialog = true;
        },
        handleMoreThanOneYearOlderWarning() {
            const portfolioNamePrefix = this.getUILabel("common_portfolio").toLowerCase();
            const conjunction = this.getUILabel("and");
            const portfolioWarning = this.$store.getters["investments/portfolioOlderThanOneYearWarning"](portfolioNamePrefix, conjunction);
            if (portfolioWarning) {
                const olderThanOneYearWarning = this.getUILabel("portfolio_report_more_than_one_year_older_warning", {
                    portfolioReportWarning: portfolioWarning
                });
                const notification = {
                    size: "medium",
                    variation: "warning",
                    title: "",
                    persistent: false,
                    text: olderThanOneYearWarning
                };
                this.$store.dispatch("notifications/showNotification", notification);
            }
        }
    },
    computed: {
        headerConfig() {
            return {
                leftButton: {
                    type: "secondary",
                    isActive: true,
                    isVisible: true,
                    label: this.getUILabel("COMMON_PREVIOUS"),
                    actionTrigger: "back"
                },
                middleButton: {
                    type: "secondary",
                    isActive: !this.hasError,
                    isVisible: true,
                    label: this.getUILabel("REPORT_GENERATOR_GENERATE_BUTTON_TEXT"),
                    actionTrigger: "generate"
                },
                rightButton: {
                    type: "primary",
                    isActive: true,
                    isVisible: true,
                    label: this.$store.state.hypo.firmSaved ? this.getUILabel("COMMON_CLOSE") : this.getUILabel("COMMON_SAVE_AND_CLOSE"),
                    actionTrigger: this.$store.state.hypo.firmSaved ? "closeNotSave" : "close"
                },
                ...this.getTitleAndStepperConfig()
            };
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .hypo-workflow-header .button.button {
    @media (min-width: 1000px) {
        max-width: 83px;
        &.button-middle {
            max-width: 105px;
        }
        &:hover {
            max-width: 200px;
        }
        &.button {
            @media (min-width: 1200px) {
                max-width: 200px;
            }
        }
    }
}
</style>
